import React, { useEffect } from 'react';
import Header from '../functions/header';
import Footer from '../functions/footer';
import { Link, useLocation } from 'react-router-dom';

const ThankYou = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.formSubmitted && window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-10796256823/JFHQCNj_uIwdELech5wo',
        value: 1.0,
        currency: 'USD'
      });

      // Prevent duplicate conversion on refresh
      window.history.replaceState(
        { ...window.history.state, usr: null },
        ''
      );
    }
  }, [location.state]);

  return (
    <div>
      <Header />

      <main style={{ textAlign: 'center', padding: '100px 20px' }}>
        <h1>Thank You!</h1>
        <p>Your message has been sent successfully.</p>
        <p>We'll get back to you as soon as possible.</p>

        <Link to="/">Return to Home</Link>
      </main>

      <Footer />
    </div>
  );
};

export default ThankYou;